module.exports = __webpack_public_path__ + "media/images/sponsorBox__bg-dcef69193fffbee5af669cecb109a1a5.jpg";